// @ts-nocheck
/**
 * PDP Buy Now reward modal — isolated from cart drawer reconcile.
 * Clears cart, adds line items with _july_offer / _cabin_bag properties, then redirects to checkout.
 */
(function pdpRewardBuyNow() {
  const PROP_CABIN = '_cabin_bag';
  const PROP_JULY = '_july_offer';
  const ATTR_SELECTED = 'selected_reward';

  /** @type {{ variantId: number, priceCents: number }} */
  let variantCache = { variantId: 0, priceCents: 0 };

  /** @type {HTMLFormElement | null} */
  let pendingForm = null;

  function cfg() {
    return window.CART_REWARD_CONFIG || {};
  }

  function isEnabled() {
    const c = cfg();
    return !!c.enabled && !!c.cabinBagVariantId;
  }

  function tierConfig() {
    const c = cfg();
    return {
      orMinCents: Math.round(Number(c.tierOrMin || 400) * 100),
      comboMinCents: Math.round(Number(c.tierCabinComboMin || 751) * 100),
      discountBoostMinCents: Math.round(Number(c.tierDiscountBoostMin || 1501) * 100),
    };
  }

  function getOfferTierKey(subtotalCents) {
    const { orMinCents, comboMinCents, discountBoostMinCents } = tierConfig();
    if (subtotalCents >= discountBoostMinCents) return 'boost';
    if (subtotalCents >= comboMinCents) return 'combo';
    if (subtotalCents >= orMinCents) return 'or';
    return 'belowOr';
  }

  function formatOfferLabelHtml(html) {
    if (!html || typeof html !== 'string') return html;

    let result = html;

    result = result.replace(
      /<em>\s*FLAT\s*<\/em>\s*<em>\s*<strong>(\s*\d+%)\s*<\/strong>\s*<\/em>\s*<em>\s*OFF\s*<\/em>/gi,
      'FLAT<br><strong>$1 OFF</strong>'
    );

    result = result.replace(
      /<strong>\s*FLAT\s+(\d+%)\s*OFF\s*<\/strong>/gi,
      'FLAT<br><strong>$1 OFF</strong>'
    );

    result = result.replace(
      /(Cabin Bag\s*\+)\s*<strong>(\s*\d+%\s*)<\/strong>\s*Off/gi,
      '$1<br><strong>$2Off</strong>'
    );

    result = result.replace(/(Cabin Bag\s*\+)(?!<br)\s*<strong>/gi, '$1<br><strong>');

    return result;
  }

  function getTierTexts(subtotalCents) {
    const texts = cfg().tierTexts || {};
    const tier = getOfferTierKey(subtotalCents);
    if (tier === 'belowOr') {
      return { cabinHtml: null, discountHtml: texts.belowOr || '<p>20% discount on your Purchase</p>' };
    }
    const tierTexts = texts[tier] || {};
    let cabinHtml = formatOfferLabelHtml(tierTexts.cabin || null);
    let discountHtml = formatOfferLabelHtml(tierTexts.discount || null);

    if (tier === 'combo') {
      if (!cabinHtml && cfg().cabinComboFallbackHtml) {
        cabinHtml = formatOfferLabelHtml(cfg().cabinComboFallbackHtml);
      }
      if (!discountHtml && cfg().discountComboFallbackHtml) {
        discountHtml = formatOfferLabelHtml(cfg().discountComboFallbackHtml);
      }
    }

    return { cabinHtml, discountHtml };
  }

  function showOrChoice(subtotalCents) {
    return subtotalCents >= tierConfig().orMinCents;
  }

  function getDiscountPct(subtotalCents) {
    return subtotalCents >= tierConfig().discountBoostMinCents ? 25 : 20;
  }

  function getModal() {
    return document.querySelector('[data-pdp-reward-buy-now-modal]');
  }

  function getPrimaryPdpAddToCartForm() {
    const byMain = document.querySelector(
      '.main-product-page product-form-component form[data-type="add-to-cart-form"]'
    );
    if (byMain instanceof HTMLFormElement) return byMain;
    const fallback = document.querySelector('product-form-component form[data-type="add-to-cart-form"]');
    return fallback instanceof HTMLFormElement ? fallback : null;
  }

  function extractLinePropertiesFromProductForm(form) {
    const fd = new FormData(form);
    const props = {};
    for (const [key, rawVal] of fd.entries()) {
      if (!key.startsWith('properties[')) continue;
      const match = /^properties\[(.+)\]$/.exec(key);
      if (!match) continue;
      props[match[1]] = typeof rawVal === 'string' ? rawVal : String(rawVal);
    }
    return props;
  }

  function isFormRewardExcluded(form) {
    const root = form.closest('product-form-component');
    if (root?.dataset?.cartRewardExcluded === 'true') return true;
    const props = extractLinePropertiesFromProductForm(form);
    const excluded = props['_cart_reward_excluded'];
    if (excluded === 'true' || excluded === 'True' || excluded === true) return true;
    const fifty = props['_equalorabove50%discount'];
    if (fifty === 'true' || fifty === 'True' || fifty === true) return true;
    const twenty = props['_cart_reward_20_off'];
    return twenty === 'true' || twenty === 'True' || twenty === true;
  }

  function propertiesToCartAddFormat(props) {
    const out = {};
    Object.entries(props || {}).forEach(([k, v]) => {
      if (v === undefined || v === null || v === '') return;
      out[k] = String(v);
    });
    return out;
  }

  /** @param {HTMLButtonElement[]} locked */
  function unlockButtons(locked) {
    locked.forEach((btn) => {
      if (!(btn instanceof HTMLButtonElement)) return;
      if (btn.dataset.pdpRewardBuyLocked !== '1') return;
      btn.disabled = btn.dataset.pdpRewardBuyPrevDisabled === '1';
      delete btn.dataset.pdpRewardBuyPrevDisabled;
      delete btn.dataset.pdpRewardBuyLocked;
      btn.removeAttribute('aria-busy');
    });
  }

  /** @param {HTMLFormElement} form @returns {HTMLButtonElement[]} */
  function lockPdpBuyButtons(form) {
    const seen = new Set();
    /** @type {HTMLButtonElement[]} */
    const locked = [];

    function add(btn) {
      if (!(btn instanceof HTMLButtonElement) || seen.has(btn)) return;
      seen.add(btn);
      if (btn.dataset.pdpRewardBuyLocked === '1') return;
      btn.dataset.pdpRewardBuyLocked = '1';
      btn.dataset.pdpRewardBuyPrevDisabled = btn.disabled ? '1' : '0';
      btn.disabled = true;
      btn.setAttribute('aria-busy', 'true');
      locked.push(btn);
    }

    const localRoot =
      form.closest('.main-product-page') ||
      form.closest('.shopify-section') ||
      form.closest('[id^="shopify-section"]') ||
      form;
    localRoot.querySelectorAll('.accelerated-checkout-block button').forEach((el) => add(el));
    document.querySelectorAll('sticky-add-to-cart .sticky-add-to-cart__button--buy-now').forEach((el) => add(el));
    const proceed = getModal()?.querySelector('[data-pdp-reward-proceed]');
    if (proceed instanceof HTMLButtonElement) add(proceed);

    return locked;
  }

  async function fetchVariantPriceCents(variantId) {
    if (variantCache.variantId === variantId && variantCache.priceCents > 0) {
      return variantCache.priceCents;
    }
    try {
      const res = await fetch(`/variants/${variantId}.js`, { headers: { Accept: 'application/json' } });
      if (!res.ok) return 0;
      const data = await res.json();
      const price = Number(data?.price || 0);
      if (price > 0) variantCache = { variantId, priceCents: price };
      return price;
    } catch (_) {
      return 0;
    }
  }

  function getStickyAddToCart() {
    return document.querySelector('sticky-add-to-cart');
  }

  function getQuantityFromSticky(sticky) {
    if (!sticky) return 0;

    const qtyNum = sticky.querySelector('[ref="quantityNumber"]');
    const fromDisplay = Number(qtyNum?.textContent?.trim() || 0);
    if (fromDisplay > 0) return fromDisplay;

    const qtyInput =
      document.querySelector('.main-product-page input[name="quantity"]') ||
      document.querySelector('product-form-component input[name="quantity"]') ||
      document.querySelector('input[name="quantity"]');
    if (qtyInput instanceof HTMLInputElement && qtyInput.value) {
      return Math.max(1, Number(qtyInput.value) || 1);
    }

    return Math.max(1, Number(sticky.dataset.initialQuantity || 1));
  }

  /** Sync sticky bar variant/qty into the product form before buy now. */
  function syncBuyNowContextFromSticky(form) {
    const sticky = getStickyAddToCart();
    if (!sticky) return;

    const stickyVariantId = Number(sticky.dataset.currentVariantId || 0);
    const variantInput = form.querySelector('input[name="id"]');
    if (stickyVariantId > 0 && variantInput instanceof HTMLInputElement) {
      variantInput.value = String(stickyVariantId);
    }

    const quantity = getQuantityFromSticky(sticky);
    const qtyInput =
      form.querySelector('input[name="quantity"]') ||
      document.querySelector('.main-product-page input[name="quantity"]') ||
      document.querySelector('product-form-component input[name="quantity"]');
    if (quantity > 0 && qtyInput instanceof HTMLInputElement) {
      qtyInput.value = String(quantity);
    }
  }

  function getBuyNowContext(form) {
    syncBuyNowContextFromSticky(form);

    let variantId = getVariantIdFromForm(form);
    if (!variantId) {
      variantId = Number(getStickyAddToCart()?.dataset?.currentVariantId || 0);
    }

    let quantity = getQuantityFromForm(form);
    const stickyQty = getQuantityFromSticky(getStickyAddToCart());
    if (stickyQty > 0) quantity = stickyQty;

    return { variantId, quantity: Math.max(1, quantity) };
  }

  function setModalOpenState(isOpen) {
    const body = document.body;

    if (isOpen) {
      const scrollY = window.scrollY;
      body.dataset.pdpRewardScrollY = String(scrollY);
      body.classList.add('pdp-reward-buy-now-open');

      if (isMobileSheet()) {
        body.classList.add('is-mobile-sheet-locked');
        body.style.top = `-${scrollY}px`;
      }

      return;
    }

    const scrollY = Number(body.dataset.pdpRewardScrollY || 0);
    body.classList.remove('pdp-reward-buy-now-open', 'is-mobile-sheet-locked');
    body.style.top = '';
    delete body.dataset.pdpRewardScrollY;

    if (scrollY > 0) {
      window.scrollTo(0, scrollY);
    }
  }

  function getQuantityFromForm(form) {
    const fd = new FormData(form);
    return Math.max(1, Number(fd.get('quantity')) || 1);
  }

  function getVariantIdFromForm(form) {
    const raw = new FormData(form).get('id');
    const id = raw != null && raw !== '' ? Number(raw) : NaN;
    return Number.isFinite(id) ? id : 0;
  }

  function updateModalUi(subtotalCents) {
    const modal = getModal();
    if (!modal) return;

    const texts = getTierTexts(subtotalCents);
    const cabinLabel = modal.querySelector('[data-pdp-reward-cabin-label]');
    const discountLabel = modal.querySelector('[data-pdp-reward-discount-label]');
    const discountBadge = modal.querySelector('[data-pdp-reward-discount-badge]');
    const cabinCard = modal.querySelector('[data-pdp-reward-cabin-card]');
    const offers = modal.querySelector('[data-pdp-reward-offers]');

    if (cabinLabel && texts.cabinHtml) cabinLabel.innerHTML = texts.cabinHtml;
    if (discountLabel && texts.discountHtml) discountLabel.innerHTML = texts.discountHtml;
    if (discountBadge) discountBadge.textContent = `${getDiscountPct(subtotalCents)}%`;

    const orChoice = showOrChoice(subtotalCents);
    if (cabinCard instanceof HTMLElement) {
      cabinCard.hidden = !orChoice;
    }
    if (offers instanceof HTMLElement) {
      offers.classList.toggle('cart-reward-selector__offers--discount-only', !orChoice);
    }

    if (!orChoice) {
      setSelectedReward('_july_offer');
    }
  }

  function setSelectedReward(reward) {
    const modal = getModal();
    if (!modal) return;

    modal.querySelectorAll('[data-pdp-reward-option]').forEach((btn) => {
      if (!(btn instanceof HTMLButtonElement)) return;
      const isSelected = btn.dataset.pdpRewardOption === reward;
      btn.classList.toggle('is-selected', isSelected);
      btn.setAttribute('aria-pressed', isSelected ? 'true' : 'false');
    });
    modal.dataset.selectedReward = reward;
  }

  function getSelectedReward() {
    const modal = getModal();
    return modal?.dataset?.selectedReward === '_july_offer' ? '_july_offer' : '_cabin_bag';
  }

  function isMobileSheet() {
    return window.matchMedia('(max-width: 749px)').matches;
  }

  const DESKTOP_MODAL_MQ = window.matchMedia('(min-width: 1051px)');

  function getProductDetailsEl() {
    return document.querySelector(
      '.main-product-page .product-details, [data-testid="product-information-details"]'
    );
  }

  function getProductDetailsContentEl() {
    const details = getProductDetailsEl();
    if (!(details instanceof HTMLElement)) return null;
    const groupBlock = details.querySelector(':scope > .group-block');
    return groupBlock instanceof HTMLElement ? groupBlock : details;
  }

  function syncDesktopModalPosition(modal) {
    if (!modal) return;

    if (!DESKTOP_MODAL_MQ.matches) {
      modal.style.removeProperty('--pdp-reward-modal-left');
      modal.style.removeProperty('--pdp-reward-modal-width');
      return;
    }

    const content = getProductDetailsContentEl();
    if (!(content instanceof HTMLElement)) return;

    const rect = content.getBoundingClientRect();
    modal.style.setProperty('--pdp-reward-modal-left', `${rect.left}px`);
    modal.style.setProperty('--pdp-reward-modal-width', `${rect.width}px`);
  }

  let desktopModalPositionBound = false;

  function bindDesktopModalPositionListeners() {
    if (desktopModalPositionBound) return;
    desktopModalPositionBound = true;

    const onReposition = () => {
      const modal = getModal();
      if (modal?.open) syncDesktopModalPosition(modal);
    };

    window.addEventListener('resize', onReposition, { passive: true });
    window.addEventListener('scroll', onReposition, { passive: true });
    DESKTOP_MODAL_MQ.addEventListener('change', onReposition);
  }

  const SHEET_CLOSE_ANIMATION_MS = 500;

  function playSheetOpenAnimation(modal) {
    const panel = modal.querySelector('.pdp-reward-buy-now__panel');

    if (!isMobileSheet()) {
      requestAnimationFrame(() => syncDesktopModalPosition(modal));
      modal.classList.add('is-sheet-visible');
      return;
    }

    if (!modal.classList.contains('is-sheet-preparing')) {
      modal.classList.add('is-sheet-preparing');
      void panel?.getBoundingClientRect();
    }

    requestAnimationFrame(() => {
      modal.classList.remove('is-sheet-preparing');
      void panel?.getBoundingClientRect();
      modal.classList.add('is-sheet-visible');
    });
  }

  function finishModalClose(modal) {
    if (modal.open) modal.close();
    modal.classList.remove('is-sheet-visible', 'is-sheet-closing', 'is-sheet-preparing');
    pendingForm = null;
    setModalOpenState(false);
  }

  function openModal(form, subtotalCents) {
    const modal = getModal();
    if (!modal || typeof modal.showModal !== 'function') return;

    pendingForm = form;
    updateModalUi(subtotalCents);
    if (showOrChoice(subtotalCents)) {
      setSelectedReward('_cabin_bag');
    }
    modal.classList.remove('is-sheet-closing', 'is-sheet-preparing', 'is-sheet-visible');
    modal.showModal();
    syncDesktopModalPosition(modal);

    if (isMobileSheet()) {
      const panel = modal.querySelector('.pdp-reward-buy-now__panel');
      modal.classList.add('is-sheet-preparing');
      void panel?.getBoundingClientRect();
    }

    setModalOpenState(true);
    playSheetOpenAnimation(modal);
  }

  function closeModal(options = {}) {
    const modal = getModal();
    if (!modal || !modal.open) {
      pendingForm = null;
      setModalOpenState(false);
      modal?.classList.remove('is-sheet-closing', 'is-sheet-preparing', 'is-sheet-visible');
      return;
    }

    if (options.immediate) {
      finishModalClose(modal);
      return;
    }

    if (isMobileSheet() && modal.classList.contains('is-sheet-visible') && !modal.classList.contains('is-sheet-closing')) {
      const panel = modal.querySelector('.pdp-reward-buy-now__panel');
      let closed = false;

      const completeClose = () => {
        if (closed) return;
        closed = true;
        panel?.removeEventListener('transitionend', onTransitionEnd);
        finishModalClose(modal);
      };

      const onTransitionEnd = (event) => {
        if (event.target !== panel || event.propertyName !== 'transform') return;
        completeClose();
      };

      panel?.addEventListener('transitionend', onTransitionEnd);
      modal.classList.add('is-sheet-closing');
      modal.classList.remove('is-sheet-visible');
      window.setTimeout(completeClose, SHEET_CLOSE_ANIMATION_MS + 50);
      return;
    }

    finishModalClose(modal);
  }

  async function proceedBuyNowWithReward(form, reward) {
    if (!form) return;

    syncBuyNowContextFromSticky(form);
    const { variantId, quantity } = getBuyNowContext(form);
    if (!variantId) {
      console.warn('cartRewardBuyNow: missing variant id');
      return;
    }

    const cabinVariantId = Number(cfg().cabinBagVariantId);
    const lineProps = extractLinePropertiesFromProductForm(form);
    delete lineProps[PROP_CABIN];
    delete lineProps[PROP_JULY];

    if (reward === PROP_CABIN) lineProps[PROP_CABIN] = 'true';
    else lineProps[PROP_JULY] = 'true';

    /** @type {HTMLButtonElement[]} */
    let locked = [];

    try {
      locked = lockPdpBuyButtons(form);

      const clearRes = await fetch('/cart/clear.js', {
        method: 'POST',
        headers: { Accept: 'application/json' },
      });
      if (!clearRes.ok) {
        console.error('cartRewardBuyNow: cart clear failed', clearRes.status);
        return;
      }

      /** @type {Array<{ id: number, quantity: number, properties: Record<string, string> }>} */
      const items = [
        {
          id: variantId,
          quantity,
          properties: propertiesToCartAddFormat(lineProps),
        },
      ];

      if (reward === PROP_CABIN && cabinVariantId > 0) {
        items.push({
          id: cabinVariantId,
          quantity: 1,
          properties: propertiesToCartAddFormat({ [PROP_CABIN]: 'true' }),
        });
      }

      const addRes = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items }),
      });
      const addJson = await addRes.json().catch(() => ({}));
      if (!addRes.ok || addJson.status) {
        console.error('cartRewardBuyNow: add failed', addJson);
        return;
      }

      await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ attributes: { [ATTR_SELECTED]: reward } }),
      });

      const lampReady =
        typeof window.syncProductLampFreebies === 'function'
          ? await window.syncProductLampFreebies().catch(() => ({
              blocked: true,
              message: 'Stock could not be confirmed. Please try Buy Now again.',
            }))
          : null;
      if (window.applyBuyNowStockResult?.(lampReady)) return;

      try {
        sessionStorage.setItem('checkoutVisit', 'true');
      } catch (_) {
        /* ignore */
      }

      closeModal({ immediate: true });
      window.location.assign('/checkout');
    } catch (error) {
      console.error('cartRewardBuyNow', error);
    } finally {
      unlockButtons(locked);
    }
  }

  async function cartRewardBuyNow() {
    if (!isEnabled()) return;

    const form = getPrimaryPdpAddToCartForm();
    if (!form) {
      console.warn('cartRewardBuyNow: product form not found');
      return;
    }
    if (!form.checkValidity()) {
      form.reportValidity();
      return;
    }
    if (isFormRewardExcluded(form)) {
      triggerNativeBuyNow(form);
      return;
    }

    syncBuyNowContextFromSticky(form);
    const { variantId, quantity } = getBuyNowContext(form);
    if (!variantId) {
      console.warn('cartRewardBuyNow: missing variant id');
      return;
    }

    let unitPriceCents = variantCache.variantId === variantId ? variantCache.priceCents : 0;
    if (!unitPriceCents) unitPriceCents = await fetchVariantPriceCents(variantId);
    if (!unitPriceCents) {
      console.warn('cartRewardBuyNow: could not resolve variant price');
      return;
    }

    const subtotalCents = unitPriceCents * quantity;

    if (!showOrChoice(subtotalCents)) {
      await proceedBuyNowWithReward(form, PROP_JULY);
      return;
    }

    openModal(form, subtotalCents);
  }

  function triggerNativeBuyNow(form) {
    const root =
      form.closest('.main-product-page') ||
      form.closest('.shopify-section') ||
      form.closest('[id^="shopify-section"]') ||
      document;
    const accelerated = root.querySelector('.shopify-payment-button__button:not([onclick])');
    if (accelerated instanceof HTMLButtonElement && !accelerated.disabled) {
      accelerated.click();
      return;
    }
    const variantId = getVariantIdFromForm(form) || Number(getStickyAddToCart()?.dataset?.currentVariantId || 0);
    const quantity = getQuantityFromSticky(getStickyAddToCart()) || getQuantityFromForm(form);
    if (variantId) window.location.assign(`/cart/${variantId}:${quantity}`);
  }

  function bindModalEvents() {
    const modal = getModal();
    if (!modal || modal.dataset.pdpRewardBound === '1') return;
    modal.dataset.pdpRewardBound = '1';

    modal.querySelector('[data-pdp-reward-close]')?.addEventListener('click', closeModal);
    modal.addEventListener('click', (event) => {
      if (event.target === modal) closeModal();
    });
    modal.addEventListener('cancel', (event) => {
      event.preventDefault();
      closeModal();
    });

    modal.querySelectorAll('[data-pdp-reward-option]').forEach((btn) => {
      btn.addEventListener('click', () => {
        const reward = btn instanceof HTMLElement ? btn.dataset.pdpRewardOption : '';
        if (reward === PROP_CABIN || reward === PROP_JULY) setSelectedReward(reward);
      });
    });

    modal.querySelector('[data-pdp-reward-proceed]')?.addEventListener('click', () => {
      if (!pendingForm) return;
      const reward = getSelectedReward();
      void proceedBuyNowWithReward(pendingForm, reward);
    });
  }

  function bindVariantPriceCache() {
    document.querySelectorAll('.main-product-page, [id^="shopify-section"]').forEach((section) => {
      section.addEventListener('variant:update', (event) => {
        const variant = event?.detail?.variant;
        if (!variant || typeof variant.price !== 'number' || !variant.id) return;
        variantCache = { variantId: Number(variant.id), priceCents: variant.price };

        if (pendingForm && getModal()?.open) {
          const qty = getBuyNowContext(pendingForm).quantity;
          updateModalUi(variant.price * qty);
        }
      });
    });
  }

  function init() {
    if (!isEnabled()) return;
    bindModalEvents();
    bindDesktopModalPositionListeners();
    bindVariantPriceCache();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.cartRewardBuyNow = cartRewardBuyNow;
})();
